import { Link } from '@bpba/ui-components';
import { RESULTADO_PATH } from '../components/catalogo/Resultado';

export class RubroData {
  labelName: string;
  id: string;

  constructor(labelName: string, id: string) {
    this.labelName = labelName;
    this.id = id;
  }

  public static getUrl(id: string | undefined) {
    if (id && typeof id === 'string' && id.trim().length > 0) {
      const path = encodeURI(id.trim());
      return `${process.env.PUBLIC_URL}${RESULTADO_PATH}/${path}`;
    }
    return undefined;
  }
  public static getLink(id: string | undefined) {
    const url = this.getUrl(id);
    return url ? new Link(url) : undefined;
  }
}
